import { render, staticRenderFns } from "./invitationManage.vue?vue&type=template&id=1e50f5b6"
import script from "./invitationManage.vue?vue&type=script&lang=js"
export * from "./invitationManage.vue?vue&type=script&lang=js"
import style0 from "./invitationManage.vue?vue&type=style&index=0&id=1e50f5b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports